import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PrimaryButton } from "./shared/Button";
import CloseIcon from "@mui/icons-material/Close";
import { theme } from "../theme";
import { scrollToSection } from "./shared/utils";
import { useNavigate, useLocation } from "react-router-dom";

const MenuStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gray};
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 10px #dadada;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 900;
  width: 100%;
  padding: 0 max(2%, 20px);
  box-sizing: border-box;
`;

const Links = styled.div(
  ({ open }) => `
  display: none;

  @media (min-width: 1000px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 600px;
    margin: 0 50px;

    & span {
      cursor: pointer;
      color: ${theme.colors.gray};
      font-weight: 500;
      font-size: 16px;

      &:hover {
        color: ${theme.colors.blue};
      }
    }
  }

  ${
    open &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    background-color: rgba(255, 255, 255, 0.97); // Fondo semi-transparente
    z-index: 1000; // Asegúrate de que esté por encima de otros elementos

    & span {
      font-size: 24px;
      color: ${theme.colors.gray};
      font-weight: 500;
    }
  `
  }
`
);

const Left = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  & img {
    height: 35px;
    width: auto;
    cursor: pointer;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  column-gap: 30px;

  & img {
    display: inline;
    cursor: pointer;

    @media (min-width: 1000px) {
      display: none;
    }
  }
`;

const CloseIconStyled = styled(CloseIcon)`
  position: fixed;
  top: 30px;
  right: 30px;
  cursor: pointer;
  display: block;

  @media (min-width: 1000px) {
    display: none !important;
  }
`;

const Menu = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const scrollToSectionAndCloseMenu = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        scrollToSection(id);
      }, 500);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <MenuStyled>
      <Left>
        <span onClick={() => scrollToSectionAndCloseMenu("top")}>
          <img src="/img/beyondthecode.svg" />
        </span>
        <Links open={open}>
          <CloseIconStyled fontSize="large" onClick={() => setOpen(false)} />
          <span onClick={() => scrollToSectionAndCloseMenu("subjects")}>
            Asignaturas
          </span>
          <span onClick={() => scrollToSectionAndCloseMenu("methodology")}>
            Metodología
          </span>
          <span onClick={() => scrollToSectionAndCloseMenu("teachers")}>
            Profesores
          </span>
          <span onClick={() => scrollToSectionAndCloseMenu("students")}>
            Alumnos
          </span>
          <span onClick={() => scrollToSectionAndCloseMenu("price")}>
            Precio
          </span>
          <span onClick={() => scrollToSectionAndCloseMenu("faq")}>FAQ</span>
        </Links>
      </Left>
      <Right>
        <PrimaryButton onClick={() => scrollToSectionAndCloseMenu("contact")}>
          Apúntate
        </PrimaryButton>
        <img src="/img/menu.svg" onClick={() => setOpen(true)} />
      </Right>
    </MenuStyled>
  );
};

export default Menu;
